module.exports = __webpack_public_path__ + "img/st-convals-logo.79d525c1.jpg";